const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

/**
 * Updates the favicon dynamically based on company logo
 * @param {string} company_code - The company code to fetch the logo for
 */
export const updateFavicon = async (company_code) => {
  if (!company_code) {
    // Reset to default favicon if no company code
    setFaviconHref('/favicon.ico');
    return;
  }

  try {
    // Fetch the company logo from the admin backend
    const response = await fetch(`${BASE_URL}/api/admin/get-company-logo?company_code=${company_code}`);
    
    if (!response.ok) {
      console.error('Failed to fetch company logo');
      setFaviconHref('/favicon.ico');
      return;
    }

    const data = await response.json();
    
    if (data.success && data.logoUrl) {
      // Construct the full URL for the logo
      const fullLogoUrl = `${BASE_URL}${data.logoUrl}`;
      setFaviconHref(fullLogoUrl);
    } else {
      setFaviconHref('/favicon.ico');
    }
  } catch (error) {
    console.error('Error fetching company logo for favicon:', error);
    setFaviconHref('/favicon.ico');
  }
};

/**
 * Helper function to set favicon href
 * @param {string} href - The URL or path to the favicon
 */
const setFaviconHref = (href) => {
  // Update or create favicon link element
  let link = document.querySelector("link[rel*='icon']");
  
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }
  
  link.href = href;
  
  // Update apple-touch-icon if exists
  const appleTouchIcon = document.querySelector("link[rel='apple-touch-icon']");
  if (appleTouchIcon) {
    appleTouchIcon.href = href;
  }
};

// Resets the favicon to the default
export const resetFavicon = () => {
  setFaviconHref('/favicon.ico');
};
